import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const WhatsAppShape = {
  phone_numbers: Yup.array()
    .label("Recipients")
    .of(Yup.string().defined())
    .min(1, "Add at least one phone number.")
    .defined(),
};

export const WhatsAppDefaults = {
  phone_numbers: [],
};

export interface WhatsAppInput {
  phone_numbers: string[];
}

yupResolver<WhatsAppInput>(Yup.object().shape(WhatsAppShape));
